import { render, staticRenderFns } from "./orgDetails.vue?vue&type=template&id=102457b7&scoped=true"
import script from "./orgDetails.vue?vue&type=script&lang=js"
export * from "./orgDetails.vue?vue&type=script&lang=js"
import style0 from "./orgDetails.vue?vue&type=style&index=0&id=102457b7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102457b7",
  null
  
)

export default component.exports